"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsSeeder__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsSeeder__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsSeeder__factory = NounsSeeder__factory;
NounsSeeder__factory.bytecode = _bytecode;
NounsSeeder__factory.abi = _abi;
